<dashboard-dialog-frame [icon]='icon()' [header]='header()' [actions]='actions' [dialogRef]='dialogRef'
	[closeX]='false'>

	<div class="match-dialog">

		<div class="match-counts">
			<div class="match-counts-attempts">{{attempts()}}</div>
			<div class="match-counts-swaps">{{swaps()}}</div>
			<div class="match-counts-no-meetings">{{noMeetings()}}</div>
			<div class="match-counts-geo-donor-score">{{geoDonorScore()}}</div>
			<div class="match-counts-geo-team-score">{{teamScore()}}</div>
		</div>

		@let data = matchData();
		@if (data) {

		<div class="match-boxes">

			<div class="match-box">
				<div class="match-box-label">Mentors with Geo Donor Flag</div>

				@if(data.donorGeoMentors.length) {
				<div class="match-box-items">
					@for(geoDonor of data.donorGeoMentors; track $index) {
					<div class="match-box-item" kendoTooltip [title]="getGeoDonorTooltip(geoDonor)" [style.background-color]="geoDonor.displayColor"></div>
					}
				</div>
				}
				@else {
				<i>None</i>
				}
			</div>

			@for(acc of data.accs; track acc.accId) {

			<div class="match-box">
				<div class="match-box-label">{{ getAccName(acc) }}</div>

				<div class="match-box-items">
					@for(team of acc.teams; track $index) {
					<div class="match-box-item" kendoTooltip [title]="team.people.matchingSummary" [style.background-color]="team.displayColor"></div>
					}
				</div>
			</div>
			}

		</div>

		}
	</div>

</dashboard-dialog-frame>